if (!('scrollBehavior' in document.documentElement.style)) {
  // eslint-disable-next-line no-unused-expressions
  import('scroll-behavior-polyfill');
}
